// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3W6Mg","footer":"ChangeClinic_footer__RBh3V"};